module.exports = __webpack_public_path__ + "img/stock5.e32086a5.png";